export default __webpack_public_path__ + "static/media/Ballroll_00218.cfcb2ae0.png";